import { Reducer } from 'redux';

import { CoinData, WalletMapping, Order } from 'app/types/api';
import { LoadingKey, ApiActions } from 'app/store/modules/api/actions';
import { reduceLoading } from 'app/store/modules/utils';

export type ApiState = {
  coinInfo: Array<CoinData>;
  walletOverTime: Array<WalletMapping>;
  orders: Array<Order>;
  loading: Partial<Record<LoadingKey, boolean>>;
};

const initialState: ApiState = {
  coinInfo: [],
  walletOverTime: [],
  orders: [],
  loading: {},
};

export const reducer: Reducer<ApiState, ApiActions> = (
  state: ApiState = initialState,
  action: ApiActions
): ApiState => {
  switch (action.type) {
    case 'api/FETCH_COIN_INFO':
      return {
        ...state,
        coinInfo: action.payload,
      };
    case 'api/UPDATE_COIN_INFO': {
      // a map rather than a findIndex per icon: coinInfo holds the whole coingecko
      // catalogue, so the scan is over tens of thousands of entries
      const iconBySymbol = new Map(action.payload.map(({ symbol, imageUrl }) => [symbol, imageUrl]));

      return {
        ...state,
        // only fills gaps, so anything coin_info already supplied still wins
        coinInfo: state.coinInfo.map(info =>
          info.imageUrl || !iconBySymbol.has(info.symbol) ? info : { ...info, imageUrl: iconBySymbol.get(info.symbol) }
        ),
      };
    }
    case 'api/FETCH_WALLET_OVER_TIME':
      return {
        ...state,
        walletOverTime: action.payload,
      };
    case 'api/FETCH_ORDERS':
      return {
        ...state,
        orders: action.payload,
      };
    case 'api/LOADING':
      return reduceLoading<LoadingKey, ApiState>(state, action.payload);
    default:
      return state;
  }
};
